import { DialogContent } from '@mui/material'
import { t } from 'i18next'

import CustomDialog from '@/components/feedback/CustomDialog'
import { ServiceRuleDetailsForm } from '@/features/site/components/availability/serviceRule/form/ServiceRuleDetailsForm'
import type { MarketProgram } from '@/features/site/types/marketProgram'
import type { ServiceRule } from '@/features/unavailability/types/serviceRule'

interface ServiceRuleDetailsEditDialogProps {
  open: boolean
  onClose: () => void
  marketProgram: MarketProgram
  customerTimeZone: string
  customerLocation: string
  customerUuid: string
  serviceRule?: ServiceRule
}

export const ServiceRuleDetailsEditDialog = (props: ServiceRuleDetailsEditDialogProps) => {
  return (
    <CustomDialog
      open={props.open}
      size="large"
      title={t('customer_details.tabs.availability.availability_details.dialog.title.edit')}
      onClose={props.onClose}
    >
      <DialogContent>
        <ServiceRuleDetailsForm
          marketProgram={props.marketProgram}
          serviceRule={props.serviceRule}
          siteLocation={props.customerLocation}
          siteTimezone={props.customerTimeZone}
          siteUuid={props.customerUuid}
          onClose={props.onClose}
        />
      </DialogContent>
    </CustomDialog>
  )
}
